import _Object$freeze from "@babel/runtime-corejs3/core-js-stable/object/freeze";var boxShadows = _Object$freeze({
  dark: {
    2: '0px 2px 4px rgba(0, 0, 0, 0.16)',
    4: '0px 4px 8px rgba(0, 0, 0, 0.14)',
    8: '0px 8px 16px rgba(0, 0, 0, 0.14);',
    16: '0px 16px 24px rgba(0, 0, 0, 0.12)',
    24: '0px 24px 32px rgba(0, 0, 0, 0.1)'
  },
  light: {
    2: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    4: '0px 4px 16px rgba(0, 0, 0, 0.08)',
    8: '0px 8px 16px rgba(0, 0, 0, 0.08)',
    16: '0px 16px 24px rgba(0, 0, 0, 0.06)',
    24: '0px 24px 32px rgba(0, 0, 0, 0.06)'
  }
});

export default boxShadows;
//# sourceMappingURL=boxShadows.js.map